import {
  bulkEditSteps,
  bulkEditFields,
  BulkEditModalProps,
  fieldOptions
} from './constants';
import {
  SelectField,
  EditAdGroupDatesTimes,
  EditBidStrategy,
  EditCreatives,
  ReviewEdits,
  ApplyEdits,
} from './components';
import { useBulkEdit } from './context';

const BulkEditModalContent = ({
  data,
}: BulkEditModalProps) => {
  const { adGroups = [], campaign } = data;

  const {
    // State
    step,
    field,
    fieldValues,
    isNextEnabled,
    ids,
    invalidCount,
    rowSelectionModel,
    tableRows,
    isValidating,
    isUpdating,
    bidStrategyOptions,

    // Methods
    handleBackButton,
    handleSelectField,
    handleDatesTimesSubmit,
    handleBidStrategySubmit,
    handleCreativesSubmit,
    handleApplyEdits,
    handleSelectionChange,
    handleModalClose,
    setStep
  } = useBulkEdit();

  return (
    <>
      <SelectField
        open={step === bulkEditSteps.SELECT_FIELD}
        onCancel={handleModalClose}
        fieldOptions={fieldOptions}
        onSelectField={handleSelectField}
      />

      <EditCreatives
        open={
          step === bulkEditSteps.EDIT_FIELD &&
          field === bulkEditFields.AD_GROUP_CREATIVE
        }
        fieldValues={fieldValues}
        onCancel={handleModalClose}
        onBack={handleBackButton}
        isValidating={isValidating}
        isDisplay={false}
        onSubmit={handleCreativesSubmit}
      />

      <EditAdGroupDatesTimes
        open={
          step === bulkEditSteps.EDIT_FIELD &&
          field === bulkEditFields.AD_GROUP_DATES_TIMES
        }
        alreadyStarted={adGroups.some(adGroup => adGroup.active === true)}
        fieldValues={fieldValues}
        onSubmit={handleDatesTimesSubmit}
        onCancel={handleModalClose}
        onBack={handleBackButton}
        isValidating={isValidating}
        campaign={campaign}
        adGroups={adGroups}
      />

      {bidStrategyOptions.length > 0 && (
        <EditBidStrategy
          open={
            step === bulkEditSteps.EDIT_FIELD &&
            field === bulkEditFields.AD_GROUP_BID_STRATEGY
          }
          fieldValues={fieldValues}
          bidStrategyOptions={bidStrategyOptions}
          recommendedBidRange={[12, 18]}
          onSubmit={handleBidStrategySubmit}
          onCancel={handleModalClose}
          onBack={handleBackButton}
          isValidating={isValidating}
        />
      )}

      <ReviewEdits
        open={step === bulkEditSteps.REVIEW_EDITS}
        rows={tableRows || []}
        invalidCount={invalidCount}
        handleSelectionChange={handleSelectionChange}
        onCancel={handleModalClose}
        onBack={handleBackButton}
        onNext={() => setStep(bulkEditSteps.APPLY_EDITS)}
        isNextEnabled={isNextEnabled}
        isUpdating={isUpdating}
        showWarning={field === bulkEditFields.AD_GROUP_DATES_TIMES}
        rowSelectionModel={rowSelectionModel}
      />

      <ApplyEdits
        open={step === bulkEditSteps.APPLY_EDITS}
        ids={ids}
        adGroups={adGroups}
        fieldValues={fieldValues !== 'None' ? fieldValues : {}}
        onDone={handleModalClose}
        onApplyEdits={handleApplyEdits}
      />
    </>
  );
};

export default BulkEditModalContent;
